/**
 * Profile Card Component
 * Display email with verification status and member since
 */

import { User, Mail, Check } from 'lucide-react';
import { useLanguage } from '../../../../contexts/LanguageContext';
import { useAuthStore } from '../../../../stores/auth-store';

export function ProfileCard() {
  const { t } = useLanguage();
  const { user } = useAuthStore();

  return (
    <div className="bg-white border border-gray-200 rounded-2xl overflow-hidden hover:shadow-lg hover:border-primary-200 transition-all duration-200">
      {/* Header */}
      <div className="px-6 py-4 border-b border-gray-100">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-blue-100 rounded-lg">
            <User className="w-5 h-5 text-blue-600" />
          </div>
          <div>
            <h2 className="font-semibold text-gray-900">
              {t('settings.profile.title', 'Profile Information')}
            </h2>
            <p className="text-sm text-gray-500">
              {t('settings.profile.subtitle', 'Your account details')}
            </p>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="p-6 space-y-4">
        {/* Email */}
        <div>
          <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
            {t('settings.profile.email', 'Email Address')}
          </label>
          <div className="relative">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <Mail className="w-4 h-4 text-gray-400" />
            </div>
            <input
              id="email"
              type="email"
              value={user?.email || ''}
              disabled
              className="w-full pl-10 pr-24 py-2 bg-gray-50 border border-gray-200 rounded-lg text-gray-600 cursor-not-allowed"
            />
            <div className="absolute inset-y-0 right-0 pr-3 flex items-center">
              <span className="inline-flex items-center gap-1 px-2 py-0.5 bg-green-100 text-green-700 rounded-full text-xs font-medium">
                <Check className="w-3 h-3" />
                {t('settings.profile.verified', 'Verified')}
              </span>
            </div>
          </div>
          <p className="mt-1 text-xs text-gray-500">
            {t('settings.profile.emailNotEditable', 'Email address cannot be changed')}
          </p>
        </div>

        {/* Member since */}
        <div>
          <span className="block text-sm font-medium text-gray-700 mb-1">
            {t('settings.profile.memberSince', 'Member Since')}
          </span>
          <p className="text-gray-900">
            {user?.created_at
              ? new Date(user.created_at).toLocaleDateString(undefined, {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric',
                })
              : t('settings.profile.unknown', 'Unknown')}
          </p>
        </div>
      </div>
    </div>
  );
}
